<template>
  <a-modal
    title="创建清单"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="576"
    wrap-class-name="create-new-detailedlist-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      ref="form"
      :form="form"
    >
      <max-length-input
        :value="name"
        :required="true"
        :max="max"
        label="名称："
        fieldkey="name"
        placeholder="请输入清单名称"
        @change="handleInput"
      />
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import MaxLengthInput from '@/components/pc/MaxLengthInput'

export default {
  name: 'CreateNewDetailedListMoadl',
  components: {
    MaxLengthInput
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      name: '',
      placeholder: '请输入清单名称',
      max: 20
    }
  },

  methods: {
    ...mapActions('edm/detailedList', ['editContact']),
    handleInput (val) {
      this.name = val
    },
    hide () {
      this.$emit('update:visible', false)
      this.name = ''
      this.form.resetFields()
    },
    handleOk (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let params = {
            name: this.name
          }

          let chain = await this.editContact(params)
          chain.onSuccess((payload = '') => {
            this.hide()
            let id = payload
            this.$router.push({
              name: 'EditContactList',
              params: {
                contactid: id
              }
            })
          })
        }
      })
    },
    handleCancel () {
      this.hide()
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .ant-form-item-label {
  float: left;
  width: 120px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 120px;
}
</style>
<style lang="scss">
.create-new-detailedlist-modal {
  .ant-modal-body {
    padding: 24px 0 88px;
  }
}
</style>
